import { render } from "./Resources.vue?vue&type=template&id=24353274&scoped=true"
import script from "./Resources.vue?vue&type=script&lang=js"
export * from "./Resources.vue?vue&type=script&lang=js"

import "./Resources.vue?vue&type=style&index=0&id=24353274&scoped=true&lang=scss"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24353274"]])

export default __exports__